export default __webpack_public_path__ + "static/ASLA_Aptos_1-1ae57dec9971fe92b99267b46cb93a0d.png";